export default {"src":"/_next/static/media/c-location-icon.6b805802.svg","height":40,"width":29};